class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      HTMLUpdateUtility.setInnerHTML(sectionElement, this.getSectionInnerHTML(parsedState.sections[section.id], section.selector));
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      document.dispatchEvent(new CustomEvent('cart-drawer:rendered'));
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  renderSections(parsedState) {
    var html = parsedState.sections['cart-drawer'];
    if (!html) return;
    var newDoc = new DOMParser().parseFromString(html, 'text/html');

    var newDrawerInner = newDoc.querySelector('.drawer__inner');
    var isNowEmpty = newDrawerInner && newDrawerInner.querySelector('.drawer__inner-empty');

    if (isNowEmpty) {
      var curDrawerInner = document.querySelector('.drawer__inner');
      if (curDrawerInner && newDrawerInner) {
        curDrawerInner.innerHTML = newDrawerInner.innerHTML;
      }
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) cartDrawer.classList.add('is-empty');
    } else {
      var curEmptyState = document.querySelector('.drawer__inner-empty');
      if (curEmptyState) curEmptyState.remove();

      var newItemsEl = newDoc.querySelector('cart-drawer-items');
      var curItemsEl = document.querySelector('cart-drawer-items');
      if (newItemsEl && curItemsEl) {
        curItemsEl.classList.remove('is-empty');
        this.patchCartItems(curItemsEl, newItemsEl);
      }

      this.patchFooter(newDoc);

      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) cartDrawer.classList.remove('is-empty');
    }

    this.syncEmptyState(newDoc);

    if (parsedState.sections['cart-icon-bubble']) {
      var bubbleDoc = new DOMParser().parseFromString(
        parsedState.sections['cart-icon-bubble'], 'text/html'
      );
      var newBubble = bubbleDoc.querySelector('.shopify-section');
      var curBubble = document.getElementById('cart-icon-bubble');
      if (newBubble && curBubble) curBubble.innerHTML = newBubble.innerHTML;
    }
  }
  syncEmptyState(newDoc) {
    var newDrawer = newDoc.querySelector('cart-drawer');
    var curDrawer = document.querySelector('cart-drawer');
    if (!newDrawer || !curDrawer) return;
    var isEmpty = newDrawer.classList.contains('is-empty');
    curDrawer.classList.toggle('is-empty', isEmpty);
  }

  patchFooter(newDoc) {
    var newCheckoutBtn = newDoc.querySelector('#CartDrawer-Checkout');
    var curCheckoutBtn = document.querySelector('#CartDrawer-Checkout');
    if (newCheckoutBtn && curCheckoutBtn) {
      curCheckoutBtn.innerHTML = newCheckoutBtn.innerHTML;
      if (newCheckoutBtn.hasAttribute('disabled')) {
        curCheckoutBtn.setAttribute('disabled', '');
      } else {
        curCheckoutBtn.removeAttribute('disabled');
      }
    }

    var newDiscounts = newDoc.querySelector('.drawer__footer .discounts');
    var curFooterInner = document.querySelector('.cart-drawer__footer');
    if (curFooterInner) {
      var curDiscounts = curFooterInner.querySelector('.discounts');
      if (newDiscounts && !curDiscounts) {
        curFooterInner.insertBefore(newDiscounts, curFooterInner.firstChild);
      } else if (!newDiscounts && curDiscounts) {
        curDiscounts.remove();
      } else if (newDiscounts && curDiscounts) {
        curDiscounts.innerHTML = newDiscounts.innerHTML;
      }
    }

    var newCarousel = newDoc.querySelector('[data-carousel-container]');
    var curCarousel = document.querySelector('[data-carousel-container]');
    var curCtas = document.querySelector('.drawer__footer .cart__ctas');
    if (newCarousel && curCtas) {
      var newSlideCount = newCarousel.querySelectorAll('[data-slide-index]').length;
      var curSlideCount = curCarousel ? curCarousel.querySelectorAll('[data-slide-index]').length : 0;
      if (!curCarousel) {
        curCtas.parentNode.insertBefore(newCarousel, curCtas);
        document.dispatchEvent(new CustomEvent('cart-drawer:rendered'));
      } else if (newSlideCount !== curSlideCount) {
        curCarousel.replaceWith(newCarousel);
        document.dispatchEvent(new CustomEvent('cart-drawer:rendered'));
      }
    } else if (!newCarousel && curCarousel) {
      curCarousel.remove();
    }
  }

  patchCartItems(curEl, newEl) {
    var curRows = curEl.querySelectorAll('tr[id^="CartDrawer-Item-"]');
    var newRows = newEl.querySelectorAll('tr[id^="CartDrawer-Item-"]');

    var getRowKey = function(row) {
      var link = row.querySelector('.cart-item__name[href]');
      return link ? link.getAttribute('href') : row.id;
    };

    var curMap = {};
    curRows.forEach(function(row) { curMap[getRowKey(row)] = row; });
    var newMap = {};
    newRows.forEach(function(row) { newMap[getRowKey(row)] = row; });

    var tbody = curEl.querySelector('tbody');
    if (!tbody) {
      curEl.innerHTML = newEl.innerHTML;
      return;
    }

    curRows.forEach(function(row) {
      if (!newMap[getRowKey(row)]) row.remove();
    });

    var newArr = Array.from(newRows);
    for (var i = 0; i < newArr.length; i++) {
      var nRow = newArr[i];
      var key = getRowKey(nRow);
      var existing = curMap[key];

      if (existing) {
        existing.id = nRow.id;
        existing.className = nRow.className;

        var curTotals = existing.querySelector('.cart-item__totals');
        var newTotals = nRow.querySelector('.cart-item__totals');
        if (curTotals && newTotals) curTotals.innerHTML = newTotals.innerHTML;

        var curQtyCell = existing.querySelector('.cart-item__quantity');
        var newQtyCell = nRow.querySelector('.cart-item__quantity');
        if (curQtyCell && newQtyCell) curQtyCell.innerHTML = newQtyCell.innerHTML;

        if (tbody.children[i] !== existing) {
          tbody.insertBefore(existing, tbody.children[i] || null);
        }
      } else {
        tbody.insertBefore(nRow, tbody.children[i] || null);
        curMap[key] = nRow;
      }
    }

    var jsContents = curEl.querySelector('.js-contents');
    var newJsContents = newEl.querySelector('.js-contents');
    if (jsContents && newJsContents) {
      var lr = jsContents.querySelector('#CartDrawer-LiveRegionText');
      var nlr = newJsContents.querySelector('#CartDrawer-LiveRegionText');
      if (lr && nlr) lr.innerHTML = nlr.innerHTML;
    }
    var err = curEl.querySelector('#CartDrawer-CartErrors');
    var nerr = newEl.querySelector('#CartDrawer-CartErrors');
    if (err && nerr) err.innerHTML = nerr.innerHTML;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
